module.exports = __webpack_public_path__ + "media/bai.6643c2d4.wav";